import {SVGProps} from "react";

export default function AppLogo(props: SVGProps<SVGSVGElement>) {
    return (
        <svg width="72" height="69" viewBox="0 0 72 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M35.9947 45.9375L24.3457 68.4002H47.6704L35.9947 45.9375Z" fill="white"/>
            <path d="M35.9947 45.9375L24.3457 68.4002H47.6704L35.9947 45.9375Z" fill="url(#paint0_linear_1897_13854)"/>
            <path d="M35.9947 45.9375L24.3457 68.4002H47.6704L35.9947 45.9375Z" stroke="#AF9C2C"/>
            <path d="M0 68.4013H13.1951L35.9956 23.7512L58.796 68.4013H72L35.9956 0L0 68.4013Z" fill="white"/>
            <path d="M0 68.4013H13.1951L35.9956 23.7512L58.796 68.4013H72L35.9956 0L0 68.4013Z" fill="url(#paint1_linear_1897_13854)"/>
            <defs>
                <linearGradient id="paint0_linear_1897_13854" x1="36.008" y1="45.9375" x2="36.008" y2="68.4002" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2D56B" stopOpacity="0.59"/>
                    <stop offset="0.552083" stopColor="#F7C746" stopOpacity="0.705938"/>
                    <stop offset="1" stopColor="#FBBC28" stopOpacity="0.8"/>
                </linearGradient>
                <linearGradient id="paint1_linear_1897_13854" x1="36" y1="0" x2="36" y2="68.4013" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2D56B" stopOpacity="0.59"/>
                    <stop offset="0.552083" stopColor="#F7C746" stopOpacity="0.705938"/>
                    <stop offset="1" stopColor="#FBBC28" stopOpacity="0.8"/>
                </linearGradient>
            </defs>
        </svg>
    )
}
